// tslint:disable:max-line-length

export const msalConfig = {
    auth: {
      clientId: 'e05e2506-792d-4d3f-a247-8235de1ec835',
      authority: 'https://login.microsoftonline.com/9297f6c8-0bcc-4077-81aa-4fb9c6d1f999', // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: `${Env.FRONTEND_URL}/sso/login`,
    },
    cache: {
      cacheLocation: 'sessionStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
   scopes: ['User.Read'],
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: `${Env.API_URL}/auth/ssoLogin`,
};
